import styled, { css } from "styled-components";
import { breakpoints } from "../../../../../shared-logic/themes/toyotaTheme";
import type { NavigationVariantsType } from "./Navigation";

// STYLES
const productSpecsNavigation = css`
    ul {
        display: flex;
        flex-direction: column;
        margin: 0;
        padding: 0;
        list-style: none;
    }

    li {
        padding: var(--spacing-2);

        &:not(:nth-last-child(1)) {
            border-bottom: 1px solid var(--color-grey-4);
        }

        @media screen and (min-width: ${breakpoints.md}) {
            padding: var(--spacing-2) var(--spacing-3);
        }
    }

    a,
    button {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        font-family: var(--font-regular);
        font-size: 1.6rem;
        line-height: 2.4rem;
        color: var(--color-primary-black);
    }
`;

// COMPONENT
export const NavigationVariants = {
    "product-specs": productSpecsNavigation,
};

const NavigationVariant = styled.nav<{ variant: NavigationVariantsType }>`
    ${({ variant }) =>
        variant &&
        css`
            ${NavigationVariants[variant]};
        `}
`;

export default NavigationVariant;
